export const PAGINATION_LIMIT = 20;
export const DEFAULT_CURRENT_PAGE = 1;
export const PAGINATION_TEN_LIMIT = 10;
export const PAGINATION_ONE_HUNDRED_LIMIT = 100;
